import { I18nProvider } from './i18n/config'
import esTranslations from './i18n/es.json'
import enTranslations from './i18n/en.json'
import Layout from './components/Layout'
import Hero from './sections/Hero'
import About from './sections/About'
import Services from './sections/Services'
import Expertise from './sections/Expertise'
import Contact from './sections/Contact'
import SEO from './components/SEO'

const translations = {
  es: esTranslations,
  en: enTranslations,
}

function App() {
  return (
    <I18nProvider translations={translations}>
      <SEO />
      <Layout>
        <Hero />
        <About />
        <Services />
        <Expertise />
        <Contact />
      </Layout>
    </I18nProvider>
  )
}

export default App
